<div>
  <!-- search  -->
  <div class="form-group mb-4">
    <label
      for=""
      class="form-label"
      [translatable]="{
        transKey: titleTranslationKey,
        modEnum: titleTranslationModuleEnum
      }"
    >
      {{ title }}
      <span class="astrix-red" *ngIf="isRequired">*</span>
    </label>
    <!-- <input
      type="text"
      [(ngModel)]="query"
      class="form-control"
      (keyup)="search($event)"
    /> -->
    <!-- search field -->
    <app-search (search)="search($event)"></app-search>
  </div>
  <!-- cards -->
  <div class="team-cards-container row">
    <ng-container *ngIf="isLoadingUsers; else usersCards">
      <div class="my-4">
        <ng-container [ngTemplateOutlet]="skeleton"></ng-container>
      </div>
    </ng-container>
  </div>
</div>
<ng-template #usersCards>
  <ng-container *ngIf="_users?.length > 0">
    <label
      *ngFor="let member of _users | search : query; let i = index"
      [for]="member?.id"
      class="team-member-card col-6"
    >
      <input
        #checkboxes
        [type]="memberToAddType === 'projectManager' ? 'radio' : 'checkbox'"
        [checked]="member.checked"
        [disabled]="member.disabled"
        (change)="onSelect($event, member)"
        [name]="memberToAddType === 'projectManager' ? 'projectManager' : null"
        [id]="member?.id"
      />
      <i class="bx bxs-check-circle"></i>
      <div class="user-container">
        <person-item [requesterItem]="member"></person-item>
      </div>
      <!-- <div class="team-member-card-details">
      <app-initials
        *ngIf="!member?.en"
        [dimensions]="{ width: 52, height: 52 }"

        [name]=" lang =='en' ? member?.fullName : name?.gullArabicName"
        [name]=" member.title[lang] "

      ></app-initials>
      <img
        *ngIf="member?.userPicture?.url"
        class="profile-img"
        [src]="member?.userPicture?.url"
        alt=""
      />
      <div>
        <span class="member-name">{{ member?.fullName }}</span>
        <span class="member-position">{{ member?.position }}</span>
      </div>
    </div> -->
    </label>
  </ng-container>
  <ng-container *ngIf="_users?.length == 0">
    <div class="no-data">
      <app-no-data
        [msgTranslationKey]="'shared.noUsersFound'"
        [selectedTranslationModuleEnum]="translationModulesEnum.shared"
        [msg]="'shared.noUsersFound' | translate"
      ></app-no-data>
    </div>
  </ng-container>
</ng-template>
<ng-template #skeleton>
  <app-skeleton-loader mode="table"></app-skeleton-loader>
  <app-skeleton-loader mode="table"></app-skeleton-loader>
  <app-skeleton-loader mode="table"></app-skeleton-loader>
  <app-skeleton-loader mode="table"></app-skeleton-loader>
</ng-template>
